import { workSheetConstants } from '../../_constants';

const initialState = { removeSharingWorksheetLoading: true, data: '', error: false };

export function removeSharingWorksheetReducer(state = initialState, action) {
    
    switch (action.type) {
        case workSheetConstants.REQUEST_REMOVE_SHARING_WORKSHEET:
            return {
                removeSharingWorksheetLoading: true,
                data: '',
                error: false
            };
        case workSheetConstants.RECEIVE_REMOVE_SHARING_WORKSHEET:
            return {
                removeSharingWorksheetLoading: false,
                data: action.removeSharingWorksheet,
                error: false
            };
        case workSheetConstants.REMOVE_SHARING_WORKSHEET_ERROR:
            return {
                removeSharingWorksheetLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/workSheet/removeSharing.reducer.js